import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Zap } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

const CTASection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-24 bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Main CTA */}
          <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-3xl p-12 mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              {t('cta.title')}
            </h2>
            <p className="text-xl text-slate-400 mb-8 max-w-3xl mx-auto">
              {t('cta.subtitle')}
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-8">
              <a 
                href="https://dashboard.ip9.io"
                className="inline-flex items-center bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold px-8 py-4 text-lg group rounded-md font-medium transition-all duration-200"
              >
                {t('cta.startTrial')}
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </a>
              
              <a 
                href="mailto:sales@ip9.io"
                className="inline-flex items-center border border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white px-8 py-4 text-lg rounded-md font-medium transition-all duration-200"
              >
                {t('cta.contactSales')}
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-sm text-slate-400">
              <div className="flex items-center space-x-2">
                <Shield className="w-4 h-4 text-green-400" />
                <span>{t('cta.soc2Compliant')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Zap className="w-4 h-4 text-yellow-400" />
                <span>{t('cta.uptimeSLA')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="w-4 h-4 bg-green-400 rounded-full"></span>
                <span>{t('cta.support247')}</span>
              </div>
            </div>
          </div>

          {/* Secondary CTA Blocks */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-slate-900/30 backdrop-blur-sm border border-slate-800 rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-4">{t('cta.enterpriseSolutions')}</h3>
              <p className="text-slate-400 mb-6">
                {t('cta.enterpriseDescription')}
              </p>
              <a 
                href="mailto:sales@ip9.io"
                className="inline-flex items-center border border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white px-4 py-2 rounded-md font-medium transition-all duration-200"
              >
                {t('cta.talkToSales')}
              </a>
            </div>
            
            <div className="bg-slate-900/30 backdrop-blur-sm border border-slate-800 rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-4">{t('cta.developerResources')}</h3>
              <p className="text-slate-400 mb-6">
                {t('cta.developerDescription')}
              </p>
              <Link 
                to="/docs"
                className="inline-flex items-center border border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white px-4 py-2 rounded-md font-medium transition-all duration-200"
              >
                {t('cta.viewDocs')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;